import React from 'react';
import cx from 'classnames';
import InfoTilesType from '~/components/@types/infoTiles';

// Components
import InfoTileV2 from '@zola/zola-ui/src/components/PreAuth/InfoTileV2';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import InfoTilesSection from '@zola/zola-ui/src/components/PreAuth/InfoTilesSection';
// Styles
import sharedLpStyles from '~/styles/landingPageShared.module.less';
import styles from './StreamlinePlanningSection.module.less';
// Content
import infoTilesContent from './infoTilesContent';

const StreamlinePlanningSection: React.FC = (): JSX.Element => {
  const renderInfoTiles = (tiles: InfoTilesType[]) =>
    tiles.map(tile => (
      <InfoTileV2
        key={tile.className}
        className={cx(styles.infoTile)}
        heading={tile.heading}
        href={tile.ctaLink}
        dek={tile.dek}
        imgSrc={tile.imgSrc}
        imgAlt={tile.imgAlt}
        ctaLink={
          <LinkV2
            href={typeof tile.ctaLink === 'string' ? tile.ctaLink : ''}
            rel="noreferrer noopener"
            arrow
          >
            {tile.ctaCopy}
          </LinkV2>
        }
        moreSpace
      />
    ));
  return (
    <div className={cx(sharedLpStyles.outer, styles.lightGrayBg, sharedLpStyles.borderBottom)}>
      <InfoTilesSection
        className={cx(
          sharedLpStyles.sectionContainer,
          sharedLpStyles.maxWidth,
          styles.infoTilesSection
        )}
        tiles={renderInfoTiles(infoTilesContent)}
        title={
          <h2 className={cx(sharedLpStyles.sectionTitle, styles.title)}>
            Streamline Your Wedding Planning With Our Tools
          </h2>
        }
      />
    </div>
  );
};

export default StreamlinePlanningSection;
